module.exports = __webpack_public_path__ + "static/media/Rect1.32162f64.png";